import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

function ProductBar() {
    const { orderDetails } = useSelector((state) => state.orderDetails.orderDetails);

    return (
        <div className='flex items-center w-full border-t border-[#EAEAEA]'>
            {
                Object.keys(orderDetails).length > 0 && 
                <>
                    <div className="w-[46%] px-[10px] py-[6px] flex gap-2 items-center">
                        <div className="size-16 rounded-lg overflow-hidden">
                            <img className='size-full object-cover' src={orderDetails?.['Variant.VarientImgUrl'][0]} alt="" />
                        </div>

                        <div className="flex flex-col gap-1 w-[calc(100%-64px-11px)]">
                            <Link to={`/inventory-management/product/${orderDetails['Product.id']}`} className="font-semibold text-[14px] leading-6 text-[#121212] whitespace-nowrap overflow-hidden text-ellipsis">{orderDetails?.['Variant.VarientName']}</Link>

                            <p className="flex gap-1 items-center text-[#666666] font-medium">
                                <span className='text-[12px] leading-6'>
                                    {orderDetails?.['Product.productCategory'] === 'Beauty & Personal Care' ? 'Volume' : 'Size'}: {orderDetails?.['Variant.VarientSize']}
                                </span>
                                <span className='text-[12px] leading-6'>Color: {orderDetails?.['Variant.VarientColor']}</span>
                            </p>
                        </div>
                    </div>

                    <div className="w-[14%] px-[10px] py-[26px]">
                        <h1 className='font-medium text-[14px] leading-6'>{orderDetails.quantity}</h1>
                    </div>

                    <div className="w-[17%] px-[10px] py-[26px]">
                        <h1 className='font-medium text-[14px] leading-6'>₹{orderDetails?.['Product.productSellingPrice']}</h1>
                    </div>

                    <div className="w-[23%] px-[10px]">
                        <h1 className='font-medium text-[14px] leading-6'>{orderDetails['Variant.sku']}</h1>
                    </div>
                </>
            }
        </div>
    );
}

export default ProductBar;